module.exports = __webpack_public_path__ + "static/img/merchant_detail_video.3422912.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/merchant_detail_video.png
// module id = JdQ5
// module chunks = 8